export const SIDEBAR_CONFIG = {
  WIDTH_EXPANDED: 250,
  WIDTH_COLLAPSED: 80,
  LOGO_HEIGHT: 80,
} as const;

export function getSidebarWidth(open: boolean): number {
  return open ? SIDEBAR_CONFIG.WIDTH_EXPANDED : SIDEBAR_CONFIG.WIDTH_COLLAPSED;
}

export const API_CONFIG = {
  BASE_URL: import.meta.env.VITE_API_URL,
  API_VERSION: 'v1',
  TIMEOUT: 10000, // 10 seconds
};

export const AUTH_CONFIG = {
  TOKEN_KEY: 'authToken',
  USER_KEY: 'user',
  REFRESH_TOKEN_KEY: 'refreshToken',
};

export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  REGISTER: '/register',
  DASHBOARD: '/dashboard',
  PROFILE: '/profile',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
};

export const VALIDATION_RULES = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PASSWORD_MIN_LENGTH: 6,
  NAME_MIN_LENGTH: 2,
};

export const ERROR_MESSAGES = {
  REQUIRED_FIELD: 'This field is required',
  INVALID_EMAIL: 'Please enter a valid email address',
  PASSWORD_TOO_SHORT: 'Password must be at least 6 characters',
  NAME_TOO_SHORT: 'Name must be at least 2 characters',
  NETWORK_ERROR: 'Network error. Please check your connection.',
  UNAUTHORIZED: 'You are not authorized to access this resource.',
  SERVER_ERROR: 'Server error. Please try again later.',
};
